import React from 'react'

import Menu from '../components/Menu/Menu'
import Layout from '../components/Layout/Layout'

const MenuPage = ({ pathContext: { locale } }) => (
  <Layout locale={locale}>
    <Menu />
  </Layout>
)

export default MenuPage



// WEBPACK FOOTER //
// ./src/pages/menu.js